import type { NoyoDifferenceField } from 'enrollment-platform/api/partner-benefit-graph/noyo-differences.types'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function joinName(first: unknown, last: unknown): string | undefined {
  const parts = [first, last].filter(
    (part): part is string => typeof part === 'string'
  )
  const name = parts.join(' ').trim()
  return name.length > 0 ? name : undefined
}

function nameFromValue(value: unknown): string | undefined {
  if (!isRecord(value)) {
    return undefined
  }

  const personName = joinName(value.first_name, value.last_name)
  if (personName) {
    return personName
  }

  return joinName(value.member_first_name, value.member_last_name)
}

export type MemberFieldSide = 'platform' | 'carrier'

export function memberNameFromFields(
  fields: NoyoDifferenceField[] | undefined,
  side: MemberFieldSide
): string | undefined {
  if (fields == null) {
    return undefined
  }

  for (const field of fields) {
    const value =
      side === 'platform' ? field.platform_value : field.carrier_value
    const name = nameFromValue(value)
    if (name) {
      return name
    }
  }

  return undefined
}

export function planIdFromFields(
  fields: NoyoDifferenceField[] | undefined
): string | undefined {
  if (fields == null) {
    return undefined
  }

  for (const field of fields) {
    for (const value of [field.platform_value, field.carrier_value]) {
      if (!isRecord(value)) {
        continue
      }
      if (typeof value.plan_id === 'string' && value.plan_id.length > 0) {
        return value.plan_id
      }
    }
  }

  return undefined
}
